import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { QuoteIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonials } from '../../lib/data';
import { Eyebrow } from '../ui/Reveal';
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const active = testimonials[index];
  const go = (dir: number) => setIndex(i => (i + dir + testimonials.length) % testimonials.length);
  return <section className="bg-ivory-200/60" data-id="element-131" data-mp="3fe0qrjyw61x8">
      <div className="mx-auto max-w-4xl px-6 py-20 text-center lg:py-28" data-id="element-132" data-mp="3aibq1db4yezc">
        <div className="flex justify-center" data-id="element-133" data-mp="35hxjy0t3hf3y">
          <Eyebrow data-id="element-134" data-mp="35gme7vg39xa7">In their words</Eyebrow>
        </div>
        <QuoteIcon className="mx-auto mt-8 h-10 w-10 text-gold" data-id="element-135" data-mp="31h56evd6wo1v" />

        <div className="relative mt-6 min-h-[220px] sm:min-h-[200px]" data-id="element-136" data-mp="31iyf0g7d5ici">
          <AnimatePresence mode="wait" data-id="element-137" data-mp="1u4ljlzwjnemj">
            <motion.blockquote key={index} initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -16
          }} transition={{
            duration: 0.5,
            ease: [0.16, 1, 0.3, 1]
          }} data-id="element-138" data-mp="1q1gk867rft24">
              <p className="font-serif text-2xl leading-relaxed text-ink sm:text-3xl" data-id="element-139" data-mp="347hupeadq9n5">
                “{active.quote}”
              </p>
              <footer className="mt-8" data-id="element-140" data-mp="2uavbetxpbqn8">
                <p className="font-medium text-ink" data-id="element-141" data-mp="2u9tpfuf5djqq">{active.name}</p>
                <p className="mt-1 text-sm text-ink-500" data-id="element-142" data-mp="2gjq6bcbke65i">
                  {active.role}, {active.company}
                </p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-8 flex items-center justify-center gap-4" data-id="element-143" data-mp="26n55l36kvh7h">
          <button onClick={() => go(-1)} aria-label="Previous testimonial" className="flex h-10 w-10 items-center justify-center rounded-full border border-ink/15 text-ink-600 transition-colors hover:border-ink hover:text-ink" data-id="element-144" data-mp="2bk58x6c1m5uw">
            <ChevronLeftIcon className="h-4 w-4" data-id="element-145" data-mp="8409cen3b20s" />
          </button>
          <div className="flex gap-2" data-id="element-146" data-mp="85bdifkg6bsf">
            {testimonials.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Go to testimonial ${i + 1}`} className={`h-2 rounded-full transition-all duration-300 ${i === index ? 'w-6 bg-gold' : 'w-2 bg-ink/20 hover:bg-ink/40'}`} data-id="element-147" data-mp="3bqo3bwx6q4u" data-mpi={i} />)}
          </div>
          <button onClick={() => go(1)} aria-label="Next testimonial" className="flex h-10 w-10 items-center justify-center rounded-full border border-ink/15 text-ink-600 transition-colors hover:border-ink hover:text-ink" data-id="element-148" data-mp="m3jfx30965az">
            <ChevronRightIcon className="h-4 w-4" data-id="element-149" data-mp="32sf80pz92icd" />
          </button>
        </div>
      </div>
    </section>;
}